export const DEFAULT_CONTACT_EMAIL = 'info@ucademy.com';

export const EMAIL_REGEX = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export enum EEmailType {
  NEW_LIVERECORD = 'NEW_LIVERECORD',
  NEW_POST = 'NEW_POST',
  DELIVERABLE_MESSAGE_CREATED = 'DELIVERABLE_MESSAGE_CREATED',
  TICKET_MESSAGE_CREATED = 'TICKET_MESSAGE_CREATED',
  PROBLEM_REPORT_CREATED = 'PROBLEM_REPORT_CREATED',
  PROBLEM_REPORT_SOLVED = 'PROBLEM_REPORT_SOLVED',
  TUTOR_ASSIGNED = 'TUTOR_ASSIGNED',
  NEW_EXAM_GROUP_EXAM = 'NEW_EXAM_GROUP_EXAM',

  PASSWORD_RECOVERY = 'PASSWORD_RECOVERY',
  TUTORING_GROUP_MEMBER_ADDED = 'TUTORING_GROUP_MEMBER_ADDED',
  TICKET_CREATED = 'TICKET_CREATED',
  DELIVERABLE_CREATED = 'DELIVERABLE_CREATED',
  NEW_CREDENTIALS = 'NEW_CREDENTIALS',
  NEW_CREDENTIAL_INTERNAL_USER = 'NEW_CREDENTIAL_INTERNAL_USER',
  NEW_CREDENTIAL_STUDENT = 'NEW_CREDENTIAL_STUDENT',
  NEW_CREDENTIAL_TEACHER = 'NEW_CREDENTIAL_TEACHER',
  FP_CONVALIDATION = 'FP_CONVALIDATION',
  WEEKLY_REPORT = 'WEEKLY_REPORT',
  REFERRAL_INVITATION = 'REFERRAL_INVITATION',
  TRANSCRIPTION_READY = 'TRANSCRIPTION_READY',
  SUBSCRIPTION_UPDATED = 'SUBSCRIPTION_UPDATED',
  NEW_ACTIVITY_REVIEW = 'NEW_ACTIVITY_REVIEW',
  PLANIFICATION_FEEDBACK = 'PLANIFICATION_FEEDBACK',
  NEW_TASK_ASSIGNED = 'NEW_TASK_ASSIGNED',
  TASK_RESOURCE_UPLOADED = 'TASK_RESOURCE_UPLOADED',
  TASK_APPROVED = 'TASK_APPROVED',
  TASK_REJECTED = 'TASK_REJECTED',
  TICKET_ASSIGNEE_UPDATED = 'TICKET_ASSIGNEE_UPDATED',
  SHARED_ACTIVITY = 'SHARED_ACTIVITY',
  STUDENTS_REPORT_REQUESTED = 'STUDENTS_REPORT_REQUESTED'
}

export enum UnsubscribableEmailType {
  NEW_POST = EEmailType.NEW_POST,
  NEW_LIVERECORD = EEmailType.NEW_LIVERECORD,
  DELIVERABLE_MESSAGE_CREATED = EEmailType.DELIVERABLE_MESSAGE_CREATED,
  TICKET_MESSAGE_CREATED = EEmailType.TICKET_MESSAGE_CREATED,
  PROBLEM_REPORT_CREATED = EEmailType.PROBLEM_REPORT_CREATED,
  PROBLEM_REPORT_SOLVED = EEmailType.PROBLEM_REPORT_SOLVED,
  TUTOR_ASSIGNED = EEmailType.TUTOR_ASSIGNED,
  NEW_EXAM_GROUP_EXAM = EEmailType.NEW_EXAM_GROUP_EXAM
}
export const UNSUBSCRIBABLE_EMAIL_TYPES_ARRAY = Object.values(UnsubscribableEmailType);

export const UNSUBSCRIBABLE_EMAIL_TYPES: ReadonlySet<EEmailType> = new Set<EEmailType>([
  EEmailType.NEW_POST,
  EEmailType.NEW_LIVERECORD,
  EEmailType.DELIVERABLE_MESSAGE_CREATED,
  EEmailType.TICKET_MESSAGE_CREATED,
  EEmailType.PROBLEM_REPORT_CREATED,
  EEmailType.PROBLEM_REPORT_SOLVED,
  EEmailType.TUTOR_ASSIGNED,
  EEmailType.NEW_EXAM_GROUP_EXAM
]);

export function isUnsubscribableEmailType(emailType: EEmailType): boolean {
  return UNSUBSCRIBABLE_EMAIL_TYPES.has(emailType);
}
